// translate router.meta.title, be used in breadcrumb sidebar tagsview
export function generateTitle(title) {
  return title
}



// WEBPACK FOOTER //
// ./src/utils/i18n.js